import React from 'react';
import { connect } from "react-redux";
import './../main.scss'
import './table.scss'
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import './datepicker.scss'
import logout from './../../../Global/logout'
import checkJwt from './../../../Global/jwtChecker'
import { AiOutlineSearch } from 'react-icons/ai'
import clientReports from './../../../API/Client/GetReports'
import hr from 'date-fns/locale/hr';
import 'moment/locale/hr'

export class Search extends React.Component{

    componentDidMount = async () => {
        let startDate = new Date()
        startDate.setDate(startDate.getDate() - 1)
        this.setStartDate(startDate)
    }

    searchIzvjestaji = async () =>{
        const unHashedJwt = await checkJwt()
  
        if(!unHashedJwt){
            logout()
        }      
        
        this.props.mapState("CLIENT_MAP_LOADING_IZVJESTAJI", true)
  
        const invoices = await clientReports(
            this.props.startDate,
            this.props.endDate
        )

        if(!invoices.error){
            await this.props.mapState("CLIENT_MAP_IZVJESTAJI", invoices.data) 
            await this.props.mapState("CLIENT_MAP_IZVJESTAJI_START_DATE_IZVJESTAJI", this.props.startDate)
            await this.props.mapState("CLIENT_MAP_IZVJESTAJI_END_DATE_IZVJESTAJI", this.props.endDate)
        }
        else{
            //logout()
        }

        this.props.mapState("CLIENT_MAP_LOADING_IZVJESTAJI", false)
    }

    setStartDate(date){
        this.props.mapState("CLIENT_MAP_IZVJESTAJI_START_DATE", date)
        if(date > this.props.endDate){
            this.props.mapState("CLIENT_MAP_IZVJESTAJI_END_DATE", date)
        }
    }

    setEndDate(date){
        this.props.mapState("CLIENT_MAP_IZVJESTAJI_END_DATE", date)
    }

    render(){
        return(     
            <div style={{border: "2px solid gray", padding: "20px"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <div className="form-group row">
                                <label htmlFor="datumOd" className="col-sm-6 col-form-label">Datum od</label>
                                <div className="col-sm-6 col-form">                        
                                    <DatePicker
                                        selected={this.props.startDate}
                                        onChange={date => this.setStartDate(date)}
                                        selectsStart
                                        startDate={this.props.startDate}
                                        endDate={this.props.endDate}
                                        locale={hr}
                                        dateFormat="dd.MM.yyyy"
                                        maxDate={new Date()}
                                    />
                                </div>
                            </div>                             
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12"> 
                            <div className="form-group row">
                                <div className="col-sm-6 col-form-label" ><strong>do</strong></div>
                                <div className="col-sm-6 col-form"> 
                                    <DatePicker
                                        selected={this.props.endDate}
                                        onChange={date => this.setEndDate(date)}
                                        selectsEnd
                                        startDate={this.props.startDate}
                                        endDate={this.props.endDate}
                                        minDate={this.props.startDate}
                                        locale={hr}
                                        dateFormat="dd.MM.yyyy"
                                        maxDate={new Date()}
                                    />
                                </div> 
                            </div>
                        </div>  
                        <div className="col"> 
                            <div className="form-group row">
                                <div className="col-sm-6 col-form-label">
                                    <div 
                                        className="btn btn-light" 
                                        style={{float:"right", fontSize: "1.5rem"}} 
                                        onClick={this.searchIzvjestaji}
                                    >
                                        <AiOutlineSearch/> Traži
                                    </div> 
                                </div>
                            </div>
                        </div>              
                    </div>
                   
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {        
        startDate: state.clientIzvjestaji.startDate,
        endDate: state.clientIzvjestaji.endDate
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Search);

